var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: { label: _vm.formFields.checkSatelite.label },
                on: { change: _vm.checkActividad },
                model: {
                  value: _vm.formFields.checkSatelite.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkSatelite, "value", $$v)
                  },
                  expression: "formFields.checkSatelite.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: { label: _vm.formFields.checkHDOP.label },
                on: { change: _vm.checkActividad },
                model: {
                  value: _vm.formFields.checkHDOP.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkHDOP, "value", $$v)
                  },
                  expression: "formFields.checkHDOP.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: { label: _vm.formFields.checkLongYLat.label },
                on: { change: _vm.checkActividad },
                model: {
                  value: _vm.formFields.checkLongYLat.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkLongYLat, "value", $$v)
                  },
                  expression: "formFields.checkLongYLat.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: { label: _vm.formFields.checkDatoConfiable.label },
                on: { change: _vm.checkActividad },
                model: {
                  value: _vm.formFields.checkDatoConfiable.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkDatoConfiable, "value", $$v)
                  },
                  expression: "formFields.checkDatoConfiable.value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "FormFieldsContainer",
        [
          _c("v-flex", { attrs: { md12: "" } }, [
            _c("div", { staticClass: "v-title", attrs: { align: "left" } }, [
              _c("h2", [_vm._v("\n          Tipo de Actividad\n        ")])
            ])
          ]),
          _c(
            "v-flex",
            { attrs: { md6: "" } },
            [
              _c("BuscadorOperacionCrud", {
                attrs: {
                  filter:
                    _vm.gridApi && _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c(
            "v-flex",
            [
              _c("MantenedorGrid", {
                attrs: { "grid-options": _vm.gridOptionsActividad }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }